import { defaultConfig } from './defaultConfig';
export const createConfig = (userConfig) => ({
    ...defaultConfig,
    ...userConfig,
    events: {
        ...defaultConfig.events,
        ...userConfig.events,
    },
});
